import debounce from '../../../assets/js/base/_debounce.js';

const form = document.querySelector( '.member-directory-gated' );

if ( form ) {
	const results     = form.querySelectorAll( '.member-directory-gated__result' );
	const empty       = form.querySelector( '.member-directory-gated__empty' );
	const filterInput = form.querySelector( 'input[name="filter"]' );
	const stateSelect = form.querySelector( 'select[name="state"]' );
	const typeSelect  = form.querySelector( 'select[name="type"]' );

	const members = Array.from( results ).map( result => {
		return {
			node : result,
			text : result.textContent.toLowerCase().replace( /\s/g, '' ),
			state: result.dataset.state,
			type : result.dataset.type,
		}
	} );

	const applyFilters = () => {
		const filterValue = filterInput.value.toLowerCase().replace(/\s/g, '');
		let visible = 0;

		members.forEach( member => {
			member.node.classList.remove( 'nth-child-odd' );
			member.node.classList.remove( 'nth-child-even' );
			let matches = true;

			if ( filterValue || typeSelect.value || stateSelect.value ) {
				const appliedFilterResults = [];

				if ( filterValue ) {
					appliedFilterResults.push( member.text.indexOf( filterValue ) > -1 );
				}

				if ( typeSelect.value ) {
					appliedFilterResults.push( member.type === typeSelect.value );
				}

				if ( stateSelect.value ) {
					appliedFilterResults.push( member.state === stateSelect.value );
				}

				if ( appliedFilterResults.filter( v => ! v ).length ) {
					matches = false;
				}
			}

			if ( matches ) {
				visible++;
				member.node.classList.add( visible % 2 === 0 ? 'nth-child-even' : 'nth-child-odd' );
				member.node.removeAttribute('hidden');
			} else {
				member.node.hidden = true;
			}

		} );

		if ( visible > 0 ) {
			// if ( visible > 0 || ( ! filterValue && ! typeSelect.value && ! stateSelect.value ) ) {
			empty.hidden = true;
		} else {
			empty.removeAttribute( 'hidden' );
		}
	}

	stateSelect.addEventListener( 'change', applyFilters );
	typeSelect.addEventListener( 'change', applyFilters );
	filterInput.addEventListener( 'input', debounce( applyFilters, 200 ) );
	applyFilters();
}
